export const AUTH_STORAGE_KEY = 'ReactStorage__Authentication';
export const AUTH_CROSS_TAB_LOGOUT_EVENT = 'kc:auth:cross-tab-logout';
